<template>
  <div :class="{ 'center-screen' : !isMobile }">
    <div class="container">
      <Loader />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default{
    name: 'LoginAdmin',
    data(){
      return{
        token: this.$route.query.token
      }
    },
    mounted(){
      this.fetchLogin();
    },
    computed:{
    },
    methods:{
      ...mapActions("auth", ["loginAdmin"]),
      fetchLogin: function() {
        this.loginAdmin({token: this.token});
      },
    },
  }
</script>